import React, { memo } from "react";
import { useFormContext } from "react-hook-form";
import {
    Layout,
    Flex,
    SpacingBox,
    ErrorsMessages,
    DateField,
    Icon,
} from "../../../components";
import { formControls } from "../constants/forms";
import {
    getReactHookFormHelpers,
    inputMaxLengthHelpers,
    isInvalid,
} from "../../../libs/helpers/forms";
import TextField from "../../../components/textfield/textfield";
import PersonIcon from '../../../assets/images/icons/person.svg';
import CalendarIcon from '../../../assets/images/icons/calendar.svg';

const AdditionalCustomerFields = ({ hidden }) => {
    const form = useFormContext();
    const { register } = form;
    return (
        <div hidden={hidden}>
            <label
                id="names"
                htmlFor={formControls.names.key}
                className="form-control__label"
            >
                <b>{formControls.names.label}</b>
            </label>
            <TextField
                type="text"
                aria-labelledby="names"
                fluid
                placeholder={formControls.names.placeholder}
                id={formControls.names.key}
                name={formControls.names.key}

                icon={<Icon name="person" image={PersonIcon} />}
                maxLength={100}
            />

            <Layout>
                <Flex flex={1}>
                    <label
                        id="firstSurname"
                        htmlFor={formControls.firstSurname.key}
                        className="form-control__label"
                    >
                        <b>{formControls.firstSurname.label}</b>
                    </label>
                    <TextField
                        type="text"
                        aria-labelledby="firstSurname"
                        fluid
                        placeholder={formControls.firstSurname.placeholder}
                        id={formControls.firstSurname.key}
                        name={formControls.firstSurname.key}
                        icon={<Icon name="person" image={PersonIcon} />}
                        maxLength={100}
                    />

                </Flex>
                <SpacingBox mr="10" />
                <Flex flex={1}>
                    <label
                        id="lastSurname"
                        htmlFor={formControls.lastSurname.key}
                        className="form-control__label"
                    >
                        <b>{formControls.lastSurname.label}</b>
                    </label>
                    <TextField
                        type="text"
                        aria-labelledby="lastSurname"
                        fluid
                        placeholder={formControls.lastSurname.placeholder}
                        id={formControls.lastSurname.key}
                        name={formControls.lastSurname.key}
                        icon={<Icon name="person" image={PersonIcon} />}
                        maxLength={100}
                    />

                </Flex>
            </Layout>
            <label
                id="birthDate"
                htmlFor={formControls.birthDate.key}
                className="form-control__label"
            >
                <b>{formControls.birthDate.label}</b>
            </label>
            <DateField
                fluid
                id={formControls.birthDate.key}
                name={formControls.birthDate.key}
                placeholder={formControls.birthDate.placeholder}
                icon={<Icon slot="icon" name="calendar" size={18} image={CalendarIcon} />}
                {...getReactHookFormHelpers(form, formControls.birthDate.key)}
            />

        </div>
    );
};

export default memo(AdditionalCustomerFields);
